export default __webpack_public_path__ + "static/media/single-right-border-none.f1abfcf6.svg";